import { useQuery, useMutation, useQueryClient, keepPreviousData } from '@tanstack/react-query';

import {
  getAdminSessions,
  getAdminSession,
  approveSession,
  rejectSession,
  saveFieldRatings,
  type AdminSessionsParams,
} from '../services/questionnaire-admin.service';

export function useAdminSessions(params?: AdminSessionsParams) {
  return useQuery({
    queryKey: ['questionnaire-admin', 'sessions', params],
    queryFn: () => getAdminSessions(params),
    placeholderData: keepPreviousData,
  });
}

export function useAdminSession(id: string | null) {
  return useQuery({
    queryKey: ['questionnaire-admin', 'session', id],
    queryFn: () => getAdminSession(id!),
    enabled: !!id,
  });
}

export function useApproveSession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, approvalNotes }: { id: string; approvalNotes: string }) => approveSession(id, approvalNotes),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['questionnaire-admin'] });
    },
  });
}

export function useSaveFieldRatings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, ratings }: { id: string; ratings: Record<string, { rating: number; comment?: string }> }) =>
      saveFieldRatings(id, ratings),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['questionnaire-admin'] });
    },
  });
}

export function useRejectSession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason: string }) =>
      rejectSession(id, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['questionnaire-admin'] });
    },
  });
}
